// ================================================
// CONTATO — fonte única
// ================================================
// O site usa DOIS números de WhatsApp, que atendem canais diferentes.
// Antes deste arquivo a URL completa estava repetida em 9 lugares.
//
// TODO(cliente): confirmar qual número corresponde a cada canal.
// Hoje nada no site sinaliza a diferença para o visitante.
export const whatsapp = {
  // Usado nos CTAs principais: navbar, hero, aquicultura, /servicos, /sobre
  // e declarado no JSON-LD (schema.org) em public/index.html.
  comercial: { number: "556999805556", display: "(69) 9 9980-5556" },
  // Usado no botão flutuante e na seção de contato.
  administrativo: { number: "5569993654280", display: "(69) 9 9365-4280" },
};

export const WA_MESSAGE =
  "Olá! Vim pelo site da HidroAtiva e gostaria de mais informações sobre os serviços";

/** Monta a URL do WhatsApp a partir de um dos canais de `whatsapp`. */
export function waUrl(channel = "comercial", message = WA_MESSAGE) {
  const { number } = whatsapp[channel] ?? whatsapp.comercial;
  return `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(message)}`;
}

export const contact = {
  emails: [
    "adm@hidroativa.com.br",
    "contato@hidroativa.com.br",
    "servicos@hidroativa.com.br",
  ],
  address: {
    street: "R. Flôr do Ipê, 2130 — St. 4",
    city: "Ariquemes/RO",
    zip: "76873-474",
  },
  social: {
    instagram: "https://www.instagram.com/hidroonorte/",
    facebook: "https://www.facebook.com/share/17Tpdk3JJA/",
  },
  cnpj: "49.348.546/0001-27",
};

// ================================================
// SERVIÇOS
// ================================================
export const services = [
  {
    id: "batimetria",
    num: "i",
    title: "Batimetria de lagos e rios",
    desc: "Levantamento da profundidade de rios e lagos para estudos hidráulicos e ambientais, com sonar e instrumentação de alta precisão.",
    variant: "dark c8",
    img: "/images/batimetria.webp",
  },
  {
    id: "hidrogeologia-pontes",
    num: "ii",
    title: "Estudos hidrogeológicos para pontes e bueiros",
    desc: "Análise hidrológica e hidrogeológica para dimensionamento seguro de pontes, bueiros e travessias.",
    variant: "dark c8",
    img: "/images/bueiros.webp",
  },
  {
    id: "outorga-agua",
    num: "iii",
    title: "Outorga de uso da água subterrânea e superficial",
    desc: "Assessoria completa no processo de outorga junto à SEDAM e demais órgãos, com estudos técnicos, ART e protocolo.",
    variant: "dark c8",
    img: "/images/outorga-uso-agua.webp",
  },
  {
    id: "outorga-barragens",
    num: "iv",
    title: "Outorga de barragens",
    desc: "Regularização de barragens junto aos órgãos competentes, com estudos técnicos e documentação habilitada.",
    variant: "dark c8",
    img: "/images/OUTORGA%20DE%20BARRAGENS.webp",
  },
  {
    id: "ppci",
    num: "v",
    title: "Projeto de combate a incêndio e pânico",
    desc: "Elaboração de PPCI exigido pelo Corpo de Bombeiros Militar para edificações e estabelecimentos.",
    variant: "dark c8",
    img: "/images/Projeto%20de%20combate%20a%20inc%C3%AAndio%20e%20p%C3%A2nico.webp",
  },
  {
    id: "topografia",
    num: "vi",
    title: "Serviços de topografia",
    desc: "Levantamentos topográficos planialtimétricos para projetos de engenharia, regularizações e obras.",
    variant: "dark c8",
    img: "/images/SERVI%C3%87O-DE-TOPOGRAFIA.webp",
  },
  {
    id: "fotogrametria",
    num: "vii",
    title: "Fotogrametria com drone e RTK",
    desc: "Mapeamento aerofotogramétrico com drone e GNSS RTK, gerando ortomosaicos e modelos digitais com precisão centimétrica.",
    variant: "dark c8",
    img: "/images/FOTO-DO-DRONE.webp",
  },
  {
    id: "licenca-ambiental",
    num: "viii",
    title: "Licença ambiental simplificada e completa",
    desc: "Assessoria nos processos de licenciamento ambiental simplificado (LAS) e licenciamento completo (LP, LI, LO).",
    variant: "dark c8",
    img: "/images/Licenca-Ambiental.webp",
  },
  {
    id: "rma",
    num: "ix",
    title: "Relatório de monitoramento ambiental",
    desc: "Elaboração de RMA para acompanhamento das condicionantes e dos impactos ambientais de empreendimentos licenciados.",
    variant: "dark c8",
    img: "/images/analise-monitoramento-ambiental.webp",
  },
  {
    id: "pgrcc",
    num: "x",
    title: "Plano de gerenciamento de resíduos da construção civil",
    desc: "PGRCC para destinação adequada dos resíduos gerados em obras, conforme a Resolução CONAMA 307.",
    variant: "dark c8",
    img: "/images/Plano%20de%20gerenciamento%20de%20res%C3%ADduos%20de%20constru%C3%A7%C3%A3o%20civil.webp",
  },
  {
    id: "pgrss",
    num: "xi",
    title: "Plano de gerenciamento de resíduos de serviços da saúde",
    desc: "PGRSS para estabelecimentos de saúde, atendendo às exigências da ANVISA e dos órgãos ambientais.",
    variant: "dark c8",
    img: "/images/Plano%20de%20gerenciamento%20de%20res%C3%ADduos%20de%20servi%C3%A7os%20da%20sa%C3%BAde.webp",
  },
  {
    id: "eiv",
    num: "xii",
    title: "Estudo de impacto de vizinhança",
    desc: "EIV para avaliação dos efeitos urbanísticos, sociais e ambientais de empreendimentos sobre a vizinhança.",
    variant: "dark c8",
    img: "/images/Estudo-de-impacto-de-vizinhan%C3%A7a.webp",
  },
  {
    id: "pca",
    num: "xiii",
    title: "Plano de controle ambiental",
    desc: "PCA com medidas preventivas, mitigadoras e compensatórias dos impactos do empreendimento.",
    variant: "dark c8",
    img: "/images/PCA.webp",
  },
  {
    id: "pba",
    num: "xiv",
    title: "Plano básico ambiental",
    desc: "PBA com detalhamento dos programas ambientais exigidos como condicionantes da licença de instalação.",
    variant: "dark c8",
    img: "https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=900&q=80&auto=format&fit=crop",
  },
  {
    id: "car",
    num: "xv",
    title: "Elaboração ou retificação de CAR",
    desc: "Inscrição e retificação do Cadastro Ambiental Rural para regularização fundiária e ambiental de imóveis rurais.",
    variant: "dark c8",
    img: "/images/elabora%C3%A7%C3%A3o-retifica%C3%A7%C3%A3o-CAR.webp",
  },
  {
    id: "prodes",
    num: "xvi",
    title: "Contestação de PRODES",
    desc: "Defesa técnica e contestação de autuações vinculadas ao PRODES (desmatamento) com fundamentação geoespacial.",
    variant: "dark c8",
    img: "/images/prodes.webp",
  },
  {
    id: "prad",
    num: "xvii",
    title: "Elaboração e execução de PRAD",
    desc: "Plano de Recuperação de Áreas Degradadas, da elaboração à execução, garantindo conformidade ambiental e segurança jurídica.",
    variant: "dark c8",
    img: "/images/Elabora%C3%A7%C3%A3o-e-execu%C3%A7%C3%A3o-de-PRAD.webp",
  },
  {
    id: "agevisa",
    num: "xviii",
    title: "Projeto e memorial descritivo para AGEVISA",
    desc: "Projetos arquitetônicos e memoriais descritivos para licenciamento sanitário junto à AGEVISA.",
    variant: "dark c8",
    img: "/images/Projeto-e-memorial-descritivo-para-AGEVISA.webp",
  },
  {
    id: "pericias",
    num: "xix",
    title: "Perícia extrajudicial e judicial",
    desc: "Análises técnicas e laudos periciais habilitados para comprovação de fatos em demandas judiciais e administrativas.",
    variant: "dark c8",
    img: "/images/Per%C3%ADcia%20extrajudicial%20e%20judicial.webp",
  },
];

// ================================================
// EMPRESAS PARCEIRAS
// ================================================
// Cada parceira tem `name` e, opcionalmente, `logo` (caminho a partir de /public).
// Quando `logo` existe, o carrossel renderiza a imagem; caso contrário, mostra o nome.
// Para adicionar logos: salve o arquivo em public/partners/ e preencha o campo `logo`.
export const partners = [
  { name: "Canaã Geração de Energia Renovável S.A.", logo: "/partners/canaa_logo.png" },
  {
    name: "White Solder Metalurgia e Mineração",
    logo: "/partners/white-solder-logo.jpg",
  },
  { name: "Cooperativa de Produtores de Estanho do Brasil — COOPERTIN", logo: "/partners/coopertin_logo.png" },
  { name: "Grupo Aegea", logo: "/partners/aegea.svg" },
  {
    name: "Madeflona Industrial Madeireira Ltda.",
    logo: "/partners/madeflona.webp",
  },
  { name: "Tinkt International Trade Comércio Ltda.", logo: "/partners/logoTINKT.png" },
  {
    name: "Pampa Soluções Agrícolas Ltda.",
    logo: "/partners/MF-logo-Header.png",
    caption: "Pampa Soluções Agrícolas",
  },
  { name: "MB Limpeza Urbana Porto Velho", logo: "/partners/logo-mblimp.png" },
  { name: "Supremax Nutrição Animal", logo: "/partners/supremax.webp" },
  {
    name: "Norte Brasil Transmissora de Energia S.A.",
    logo: "/partners/evoltz.png",
    caption: "Norte Brasil Transmissora de Energia S.A.",
  },
  {
    name: "Grupo Avistar",
    logo: "/partners/avistar_logo.png",
    caption: "Grupo Avistar",
  },
  { name: "Arla Norte", logo: "/partners/arla-norte.webp" },
  { name: "Conclue Serviços de Gestão", logo: "/partners/conclue_logo.png", scale: 1.3 },
  { name: "Atenas Soluções Ambientais", logo: "/partners/atenas_logo.png", scale: 1.3 },
  { name: "RIOG Engenharia", logo: "/partners/logoBRF.jpeg" },
  { name: "Cooperativa Coopersanta", logo: "/partners/coopsanta_logo.svg" },
  { name: "Cooperativa Copermental", logo: "/partners/coopmetal_logo.svg" },
];

// ================================================
// DEPOIMENTOS
// ================================================
export const testimonials = [
  {
    name: "Jonattas Muniz",
    text: "Equipe de qualidade",
    initial: "J",
    variant: "glass",
    quoteColor: "var(--orange)",
  },
  {
    name: "Renato Muzzolon Jr.",
    text: "Excelente!",
    initial: "R",
    variant: "dark",
    quoteColor: "var(--amber)",
  },
  {
    name: "Dayane Sthefany",
    text: "Show!!!",
    initial: "D",
    variant: "orange",
    quoteColor: "rgba(255,255,255,.7)",
  },
];

// ================================================
// PILARES / VALORES
// ================================================
export const pillars = [
  {
    icon: "✦",
    title: "Honestidade",
    desc: "Transparência absoluta em prazos, custos e viabilidade real.",
    gradient: "linear-gradient(135deg,var(--orange),var(--coral))",
  },
  {
    icon: "⌬",
    title: "Equipe unida",
    desc: "Treinamento contínuo e formações que se complementam.",
    gradient: "linear-gradient(135deg,var(--ocean),var(--deep))",
  },
  {
    icon: "◈",
    title: "Sigilo total",
    desc: "Confidencialidade contratual em todas as etapas do projeto.",
    gradient: "linear-gradient(135deg,var(--mint),#4FA77F)",
  },
  {
    icon: "≈",
    title: "Inovação",
    desc: "GNSS RTK, sonar batimétrico e geoprocessamento avançado.",
    gradient: "linear-gradient(135deg,var(--amber),var(--orange))",
  },
];

// ================================================
// MAPA — presença por estado
// ================================================
export const mapPresence = {
  RO: {
    label: "Rondônia",
    desc: "Estado-sede da HidroAtiva",
    cities: [
      { n: "Ariquemes", c: [-63.04, -9.91], hq: true },
      { n: "Porto Velho", c: [-63.0, -9.3] },
      { n: "Candeias do Jamari", c: [-62.5, -9.1] },
      { n: "Itapuã do Oeste", c: [-63.32, -9.55] },
      { n: "Rio Crespo", c: [-63.2, -9.69] },
      { n: "Machadinho D'Oeste", c: [-62.01, -9.39] },
      { n: "Cujubim", c: [-62.54, -9.36] },
      { n: "Alto Paraíso", c: [-63.32, -9.99] },
      { n: "Monte Negro", c: [-63.29, -10.25] },
      { n: "Campo Novo de Rondônia", c: [-63.67, -10.57] },
      { n: "Buritis", c: [-63.4, -10.25] },
      { n: "Cacaulândia", c: [-62.9, -10.28] },
      { n: "Jaru", c: [-62.47, -10.44] },
      { n: "Ji-Paraná", c: [-61.95, -10.88] },
      { n: "Pres. Médici", c: [-61.9, -11.17] },
      { n: "Pimenta Bueno", c: [-61.19, -11.67] },
      { n: "Rolim de Moura", c: [-61.78, -11.73] },
      { n: "Cabixi", c: [-61.0, -13.0] },
    ],
  },
  AM: {
    label: "Amazonas",
    cities: [
      { n: "Manicoré", c: [-70, -5.81] },
      { n: "Apuí", c: [-59.89, -7.2] },
      { n: "Boca do Acre", c: [-67.39, -8.76] },
      { n: "Novo Aripuanã", c: [-60.38, -5.12] },
    ],
  },
  PA: { label: "Pará", cities: [{ n: "Itaituba", c: [-55.98, -4.28] }] },
  MT: {
    label: "Mato Grosso",
    cities: [{ n: "Lambari do Oeste", c: [-57.97, -15.32] }],
  },
  BA: { label: "Bahia", cities: [{ n: "Mascote", c: [-39, -15.55] }] },
};

// ================================================
// PERGUNTAS FREQUENTES (página FAQ)
// ================================================
export const faqs = [
  {
    q: "Minha empresa precisa de Licença Ambiental para funcionar?",
    a: "Muitas atividades precisam de regularização ambiental para evitar multas, embargos e problemas com os órgãos fiscalizadores.",
  },
  {
    q: "O Alvará do Corpo de Bombeiros é obrigatório?",
    a: "Sim. O documento é essencial para garantir a segurança do imóvel e o funcionamento regular da empresa perante a fiscalização.",
  },
  {
    q: "Posso fazer uso do fogo controlado sem autorização?",
    a: "Não. É necessário possuir autorização ambiental específica para realizar queimadas controladas de forma legal e segura.",
  },
  {
    q: "O que é Outorga de Uso da Água e quando preciso dela?",
    a: "A outorga é a autorização necessária para utilização de recursos hídricos, como poços, captação de água e atividades que dependem do uso da água para sua operação.",
  },
];

// ================================================
// EQUIPE (página Sobre)
// ================================================
export const team = [
  {
    name: "Equipe Técnica",
    role: "Doutores & Mestres",
    icon: "⌬",
    desc: "Profissionais com títulos de doutorado e mestrado em recursos hídricos, engenharia e geoprocessamento.",
  },
  {
    name: "Especialistas Campo",
    role: "GNSS RTK & Sonar",
    icon: "≈",
    desc: "Instrumentação de ponta para levantamentos batimétricos e geoespaciais com precisão centimétrica.",
  },
  {
    name: "Regularização",
    role: "Ambiental & Sanitária",
    icon: "◈",
    desc: "Expertise em processos junto à SEDAM, órgãos ambientais estaduais e Corpo de Bombeiros Militar.",
  },
];
